import { get } from 'lodash';
import { createSelector } from 'reselect';

import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

const root = (state) => get(state, 'ControlInformationState.taxRates');

export const getTaxRateSites = (state) => get(root(state), 'taxRateSites');
export const getSaveSitesSuccessful = (state) =>
  get(root(state), 'taxRateSaveSitesSuccessful');
export const getTaxRateLoading = (state) => get(root(state), 'loading');
export const getGetSitesError = (state) => get(root(state), 'getSitesError');
export const getSaveSitesError = (state) => get(root(state), 'saveSitesError');
export const getSaveSuccessful = (state) =>
  get(root(state), 'taxRateSaveSuccessful');
export const getDeleteSuccessful = (state) =>
  get(root(state), 'deleteSuccessful');
export const getTaxRateData = (state) => get(root(state), 'data', null);

export const getReducedTaxRateData = createSelector(getTaxRateData, (data) => {
  if (data) {
    return data.map((taxRate) => {
      const reducedData = {
        Name: taxRate.Description,
        Id: taxRate.Id,
        Sites: taxRate.SiteMaster.map((x) => x.Id),
      };
      taxRate.TaxRateByStatus.forEach(
        (x) =>
          (reducedData[
            Object.keys(StatusEnum).find((key) => StatusEnum[key] === x.Status)
          ] = x.TaxRate)
      );
      return reducedData;
    });
  } else return [];
});

export const getUsedTaxRateNames = createSelector(getTaxRateData, (data) => {
  if (data) {
    return data.map((taxRate) => {
      return taxRate.Description.trim();
    });
  }
});

export const getAllSitesWithAssignedTaxRates = createSelector(
  getTaxRateData,
  (data) => {
    const allSites = [];
    if (data) {
      return data.forEach((taxRate) => allSites.concat(taxRate.Sites));
    }
    return allSites;
  }
);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/taxRates/selectors.js